import React from 'react';
import LandPageTypes from '../LandPageTypes';
import AdminPageTypes from '../AdminPageTypes';
import Datatable from '../controls/Datatable.jsx';
import DatatablesCallbacks from '../../datatables/DatatablesCallbacks';
import _ from 'lodash';

class Events extends React.Component {
    constructor(props) {
        super(props);
    }

    render() {
        const app = this.props.app;

        if (app.landPage !== LandPageTypes.ADMIN || app.adminPage !== AdminPageTypes.EVENTS)
            return null;

        const courses = this.props.eventsStore.courses;

        if (!courses)
            return;

        const token = this.props.token;

        const editorFields = [
            { "label": "Nome", "name": "name" },
            {
                "label": "Curso",
                "name": "course.id",
                "type": "select",
                "options": _.map(courses, function (course) { return course.toJS(); }),
                "optionsPair": {
                    "label": "name",
                    "value": "id",
                }
            },
            { "label": "Endereço", "name": "endereco" },
            { "label": "Local", "name": "local" },
            {
                "label": "Valor (R$)",
                "name": "valor",
                "type": "mask",
                "mask": "000.000.000.000.000,00",
                "maskOptions": {
                    "reverse": true,
                    "placeholder": "",
                },
                "data": function (row, type) {
                    return $.datatable.renders.number(".", ",", 2).display(row.valor);
                }
            },
            {
                "label": "Tem vinculação de apostila:",
                "name":  "linkCourseware",
                "type":  "radio",
                "options": [
                    { label: "Sim", value: true },
                    { label: "Não", value: false }
                ]
            },
            {
                "label": "Date de Início",
                "name": "inicio",
                "type": "datetime",
                "format": "DD/MM/YYYY HH:mm",
                "data": function (row) {
                    return moment.parseZone(row.inicio).format('DD/MM/YYYY HH:mm');
                }
            },
            {
                "label": "Data de Conclusão",
                "name": "fim",
                "type": "datetime",
                "format": "DD/MM/YYYY HH:mm",
                "data": function (row) {
                    return moment.parseZone(row.fim).format('DD/MM/YYYY HH:mm');
                }
            },
        ];

        const hasLinkCoursewareRender = function (data, type) {
            if (type === "display") {
                if (data)
                    return '<span class="bg-success" style="padding: 1px 3px; color: white; font-weight: bold;">COM VINCULAÇÃO</span>';
                else
                    return '<span class="bg-warning" style="padding: 1px 3px; color: white; font-weight: bold;">SEM VINCULAÇÃO</span>';
            } else {
                return data ? "CONFIRMADO" : "À CONFIRMAR";
            }
        };

        const datatablesColumns = [
            { data: "selected", title: "", render: $.datatable.renders.booleanOnlyTrue("selected") },
            { data: "name", title: "Nome", render: $.datatable.renders.text() },
            { data: "course.name", title: "Curso", render: $.datatable.renders.text() },
            { data: "linkCourseware", title: "Apostila", render: hasLinkCoursewareRender },
            { data: "valor", title: "Valor (R$)", render: $.datatable.renders.money(".", ",", 2) },
            { data: "inicio", title: "Início", render: $.datatable.renders.datetime("DD/MM/YYYY HH:mm"), width: 100, searchable: false },
            { data: "fim", title: "Conclusão", render: $.datatable.renders.datetime("DD/MM/YYYY HH:mm"), width: 100, searchable: false },
            { data: "dateCreated", title: "Criação", render: $.datatable.renders.datetime(), width: 120, searchable: false },
            { data: "dateUpdated", title: "Edição", render: $.datatable.renders.datetime(), width: 120, searchable: false },
            {
                data: function (row, type) {
                    if (type === "display" && row.selected === false) {
                        return '<button type="button" data-id="' + row.id + '" class="btn btn-primary btn-xs selecionar" aria-label="Selecionar evento">' +
                            'selecionar' +
                            '</button>'
                    }

                    return null;
                },
                searchable: false,
                orderable: false,
            },
        ];

        const props = this.props;
        const postCreation = function (dt) {
            $(".events-datatables").on('click', 'button.selecionar', function (e) {
                e.preventDefault();
                props.events.onSelectEvent(
                    $(this).attr('data-id'),
                    function () {
                        dt.ajax.reload();
                    },
                    token);
            });
        };

        let callbacks = new DatatablesCallbacks({
            token: token,
            selectUrl: '/api/events/list',
            createUrl: '/api/events/insert',
            editUrl: '/api/events/update/_id_',
            removeUrl: '/api/events/delete/_id_',
        });

        const editorCreateTitle = 'Inserir evento';
        const editorEditTitle = 'Editar evento';
        const editorRemoveTitle = 'Remover evento';
        const editorRemoveMessage = 'Deseja remover este evento?';

        const domClassName = 'events-datatables';
        const title = 'Eventos';
        const subTitle = 'Gerenciamento';

        return (
            <Datatable DomClassName={domClassName}
                       title={title}
                       subTitle={subTitle}
                       order={[[1, "asc"]]}
                       responsive={true}
                       editorCreateVisible={true}
                       editorCreate={callbacks.create.bind(callbacks)}
                       editorCreateTitle={editorCreateTitle}
                       editorEditVisible={true}
                       editorEdit={callbacks.edit.bind(callbacks)}
                       editorEditTitle={editorEditTitle}
                       editorRemoveVisible={true}
                       editorRemove={callbacks.remove.bind(callbacks)}
                       editorRemoveTitle={editorRemoveTitle}
                       editorRemoveMessage={editorRemoveMessage}
                       editorFields={editorFields}
                       datatablesSelect={callbacks.select.bind(callbacks)}
                       datatablesColumns={datatablesColumns}
                       postCreation={postCreation}
            />
        );
    }
}

export default Events;


// WEBPACK FOOTER //
// src/views/pages/Events.jsx